module.exports = __webpack_public_path__ + "media/images/riders/small/JOE_SMITH-312fcc9c9b772dc53b2c76478799d7b6.png";